import { Component } from '@angular/core';

@Component({
  selector: 'bst-frontend-bst-layout',
  templateUrl: './bst-layout.component.html',
  styleUrls: ['./bst-layout.component.css'],
})
export class BstLayoutComponent {}
